import { selector } from "recoil";

import { NotificationPriorityEnum } from "../../enums";
import { RydeEventNotification } from "../../models";
import { notificationsImportantAtom, rydeEvents } from "../atoms";

export const notificationStatsSelector = selector({
  key: "notificationStatsSelector",
  get: ({ get }) => {
    const { summary } = get(notificationsImportantAtom);

    return summary.reduce(
      (acc, countSummary) => {
        if (countSummary.priority in acc) {
          acc[countSummary.priority] = countSummary.count;
          return acc;
        }

        return acc;
      },
      {
        [NotificationPriorityEnum.Alert]: 0,
        [NotificationPriorityEnum.Notice]: 0,
        [NotificationPriorityEnum.Reminder]: 0,
      },
    );
  },
});

export const notificationEvents = new Set<RydeEventNotification>([
  "NOTIFICATION_FIRED",
]);

export const notificationEventsSelector = selector({
  key: "notificationEventsSelector",
  get: ({ get }) => {
    return get(rydeEvents).filter(({ eventName, token }) =>
      notificationEvents.has(eventName as RydeEventNotification),
    );
  },
});
